"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var FlatfileUpload_1 = __importDefault(require("components/FlatfileUpload/FlatfileUpload"));
var useUploadTransactions_1 = require("containers/Admin/CustomerManagement/CompanyActions/useUploadTransactions");
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HoCs_1 = require("utils/HoCs");
var CSVUpload = function (_a) {
    var company = _a.company;
    var _b = __read((0, useUploadTransactions_1.useUploadTransactions)(company.id), 1), uploadTransactions = _b[0];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "CSV Upload", description: "integrations" }), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 1000, mx: "auto", mt: 1, mb: 2, pt: 8, pr: 6, pb: 4, pl: 6 }, { children: (0, jsx_runtime_1.jsx)(FlatfileUpload_1.default, __assign({ transactionsCaller: uploadTransactions }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, { children: "Import CSV" }) })) }))] }));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(CSVUpload);
